module.exports = __webpack_public_path__ + "img/shoulder-blast.e3ecb0de.png";